import React, { memo, useState } from "react";
import { useAppSelector } from "../../hooks/useAppSelector";
import MobileSidebar from "./components/MobileSidebar";
import DesktopSidebar from "./components/DesktopSidebar";

interface SidebarProps {
  setActiveComponent: (component: string) => void;
  setActiveAdminComponent: (component: string) => void;
  activeComponent: string;
  activeAdminComponent: string;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  setActiveComponent,
  setActiveAdminComponent,
  activeComponent,
  activeAdminComponent,
  sidebarOpen,
  setSidebarOpen,
}) => {
  const role = useAppSelector((state) => state.user.role?.toLocaleLowerCase());
  const [adminOpen, setAdminOpen] = useState(false);

  return (
    <>
      <MobileSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        adminOpen={adminOpen}
        setAdminOpen={setAdminOpen}
        role={role}
        setActiveComponent={setActiveComponent}
        setActiveAdminComponent={setActiveAdminComponent}
        activeComponent={activeComponent}
        activeAdminComponent={activeAdminComponent}
      />
      <DesktopSidebar
        adminOpen={adminOpen}
        setAdminOpen={setAdminOpen}
        role={role}
        setActiveComponent={setActiveComponent}
        setActiveAdminComponent={setActiveAdminComponent}
        activeComponent={activeComponent}
        activeAdminComponent={activeAdminComponent}
      />
    </>
  );
};

export default memo(Sidebar);
